<template>
  <div style="height: auto;width: 100%;margin-top: 5px;" class="cargo-advance-search">
    <div v-show="showSimple" class="cargo-advance-search-header">
      <div class="cargo-advance-search-toggle-trigger">
        <i
          v-show="showAdv"
          class="el-icon-arrow-left"
          :style="{transform: !isShowingMoreSearchCondition?'rotate(-90deg)':'rotate(90deg)'}"
          @click="upOrDownSearchCondition"
        />
      </div>
      <div v-show="showSimple && !isShowingMoreSearchCondition" class="cargo-advance-search-quick">
        <!--清空时不需要弹出提示，只有输入框为空，点击查询时才需要弹出提示-->
        <!--@clear="simSearch"-->
        <el-input
          ref="keyword"
          v-model="keyWords"
          style="width:200px;"
          :placeholder="simQueryPlaceholder"
          :spellcheck="false"
          @blur="keyWordBlur"
          @keyup.enter.native.prevent="toQuery"
        />
        <cargo-advance-select
          v-if="!isShowingMoreSearchCondition"
          style="width: 115px;display: inline-block;"
          filterable
          :disabled="disabled"
          :clearable="false"
          :default-value="filter.currency"
          :select-type="selectTypeNames.basic_data_Currency"
          @parentCallBack="p=>{filter.currency=p.value}"
        />
        <el-select
          v-if="!isShowingMoreSearchCondition && showLevel"
          v-model="filter.level"
          style="width:190px;display: inline-block;margin-left: 10px;"
          @change="onLevelChanged"
        >
          <el-option
            v-for="(item,index) in tiers"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div ref="searchOperations" class="cargo-advance-search-operations">
        <el-button style="margin-left: 10px" type="primary" :disabled="disabled" @click="toQuery">
          {{ $t('CargoMsg.Cargo_Query') }}
        </el-button>
        <el-button type="primary" @click="resetSearch()">{{ $t('CargoMsg.Cargo_Reset') }}</el-button>
        <slot name="operations">
          <!--页面操作按钮-->
        </slot>
      </div>
    </div>
    <slot name="searchAreaHeader">
      <!--搜索条件区域-头-->
    </slot>
    <div
      v-if="showAdv"
      v-show="isShowingMoreSearchCondition"
      class="section cargo-advance-search-more"
    >
      <div class="cargo-advance-search-more-operations">
        <div>
          <el-form label-width="80px" label-position="left" :inline="true">
            <el-radio-group v-model="rdoGroupOrg">
              <el-radio label="pol">{{ $t('Pricing.POL') }}</el-radio>
              <el-radio label="pols">{{ $t('Pricing.POLs') }}</el-radio>
              <el-radio label="col">{{ $t('Pricing.COL') }}</el-radio>
              <el-radio label="rol">{{ $t('Pricing.ROL') }}</el-radio>
            </el-radio-group>
            <cargo-advance-select
              v-if="rdoGroupOrg === 'pol'"
              filterable
              :placeholder="$t('Pricing.POLPrompt')"
              :select-type="selectTypeNames.basic_data_Seaport"
              :custom-label="(item)=>`[${item.code}]${item.englishName}`"
              :filter-tag-names="['code','englishName']"
              :show-custom-label-in-option="true"
              style="width:190px;display: inline-block;margin-left: 10px;"
              :default-value="filter.pol"
              @parentCallBack="p=>{filter.pol=p.value}"
            />
            <cargo-pop-select-input
              v-if="rdoGroupOrg === 'pols'"
              v-model="filter.pols"
              style="width:190px;display: inline-block;margin-left: 10px;"
              :column-defs="popSelectInputCols"
            />
            <cargo-advance-select
              v-if="rdoGroupOrg === 'col'"
              filterable
              :placeholder="$t('Pricing.COLPrompt')"
              :select-type="selectTypeNames.basic_data_Country"
              style="width:190px;display: inline-block;margin-left: 10px;"
              @parentCallBack="p=>{filter.col=p.value}"
            />
            <cargo-advance-select
              v-if="rdoGroupOrg === 'rol'"
              filterable
              :select-type="selectTypeNames.basic_data_Region"
              :default-value="filter.rol"
              style="width:190px;display: inline-block;margin-left: 10px;"
              @parentCallBack="p=>{filter.rol=p.value}"
            />
            <el-select
              v-model="filter.cmbCreatedBy"
              :disabled="isShowCreatedBy"
              style="width:100px;display: inline-block;margin-left: 10px;"
            >
              <el-option :label="$t('Pricing.CreatedBy')" value="createdBy" />
              <el-option :label="$t('Pricing.Branch')" value="branch" />
            </el-select>
            <cargo-advance-select
              v-if="filter.cmbCreatedBy === 'createdBy'"
              filterable
              :select-type="selectTypeNames.basic_data_User"
              :default-value="filter.createdBy"
              :callback-params="{key:'userId'}"
              style="width:190px;display: inline-block;margin-left: 10px;"
              @parentCallBack="p=>{filter.createdBy=p.value}"
            />
            <cargo-office-select
              v-if="filter.cmbCreatedBy === 'branch'"
              :disabled="false"
              :office-id="filter.branch"
              :default-value="filter.branch"
              style="width:190px;display: inline-block;margin-left: 10px;"
              @parentCallBack="p=>{filter.branch=p.value}"
            />
            <el-form-item v-if="isManageModule" :label="$t('Pricing.CreatedDate')" style="margin-left: 10px;">
              <el-date-picker
                v-model="filter.createDateFrom"
                type="date"
                style="width:130px;margin-left:10px"
                value-format="yyyy-MM-dd"
              />
              <span style="margin: 5px;">{{ $t('Pricing.EndDate') }}</span>
              <el-date-picker
                v-model="filter.createDateTo"
                type="date"
                style="width:130px;margin-left:10px"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item :label="$t('Pricing.Carrier')" style="margin-left: 10px;">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{seaCmp:true}"
                :custom-label="(item)=>`[${item.shortName}]${item.chineseName}`"
                :show-custom-label-in-option="true"
                tag-value="scac"
                style="width:190px;"
                :multiple="true"
                :default-multiple-value="filter.carrier"
                @parentCallBack="p=>{filter.carrier=p.scac}"
              />
            </el-form-item>
            <el-form-item :label="$t('Pricing.Source')" style="margin-left: 10px;">
              <el-input v-model="filter.txtBookingAgent" style="width: 100px;" />
            </el-form-item>
          </el-form>
          <el-form label-width="80px" label-position="left" :inline="true">
            <el-radio-group v-model="rdoGroupDes">
              <el-radio label="pod">{{ $t('Pricing.POD') }}</el-radio>
              <el-radio label="pods">{{ $t('Pricing.PODs') }}</el-radio>
              <el-radio label="cod">{{ $t('Pricing.COD') }}</el-radio>
              <el-radio label="rod">{{ $t('Pricing.ROD') }}</el-radio>
            </el-radio-group>
            <cargo-advance-select
              v-if="rdoGroupDes === 'pod'"
              filterable
              :placeholder="$t('Pricing.POLPrompt')"
              :select-type="selectTypeNames.basic_data_Seaport"
              :custom-label="(item)=>`[${item.code}]${item.englishName}`"
              :filter-tag-names="['code','englishName']"
              :show-custom-label-in-option="true"
              style="width:190px;display: inline-block;margin-left: 10px;"
              @parentCallBack="p=>{filter.pod=p.value}"
            />
            <cargo-pop-select-input
              v-if="rdoGroupDes === 'pods'"
              v-model="filter.pods"
              style="width:190px;display: inline-block;margin-left: 10px;"
              :column-defs="popSelectInputCols"
            />
            <cargo-advance-select
              v-if="rdoGroupDes === 'cod'"
              filterable
              :placeholder="$t('Pricing.COLPrompt')"
              :select-type="selectTypeNames.basic_data_Country"
              style="width:190px;display: inline-block;margin-left: 10px;"
              @parentCallBack="p=>{filter.cod=p.value}"
            />
            <cargo-advance-select
              v-if="rdoGroupDes === 'rod'"
              filterable
              :select-type="selectTypeNames.basic_data_Region"
              style="width:190px;display: inline-block;margin-left: 10px;"
              @parentCallBack="p=>{filter.rod=p.value}"
            />
            <el-form-item :label="$t('Pricing.BeginDate')" style="margin-left: 10px;">
              <el-date-picker
                v-model="filter.beginDate"
                type="date"
                style="width:130px;margin-left:10px"
                value-format="yyyy-MM-dd"
              />
              <span style="margin: 5px;">{{ $t('Pricing.EndDate') }}</span>
              <el-date-picker
                v-model="filter.endDate"
                type="date"
                style="width:130px;margin-left:10px"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item v-show="showLevel" :label="$t('Pricing.Level')" style="margin-left: 10px;">
              <el-select
                v-model="filter.level"
                style="width:190px;display: inline-block;margin-left: 10px;"
                @change="onLevelChanged"
              >
                <el-option
                  v-for="(item,index) in tiers"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('Pricing.Currency')" style="margin-left: 10px;">
              <cargo-advance-select
                v-model="filter.currency"
                style="width: 115px;"
                filterable
                :disabled="disabled"
                :clearable="false"
                :default-value="filter.currency"
                :select-type="selectTypeNames.basic_data_Currency"
                @parentCallBack="p=>{filter.currency=p.value}"
              />
            </el-form-item>
          </el-form>
          <el-form label-width="80px" label-position="left" :inline="true">
            <el-checkbox v-model="filter.direct">{{ $t('Pricing.Direct') }}</el-checkbox>
            <el-checkbox v-model="filter.frequency1">{{ $t('Pricing.Mon') }}</el-checkbox>
            <el-checkbox v-model="filter.frequency2">{{ $t('Pricing.Tue') }}</el-checkbox>
            <el-checkbox v-model="filter.frequency3">{{ $t('Pricing.Wed') }}</el-checkbox>
            <el-checkbox v-model="filter.frequency4">{{ $t('Pricing.Thu') }}</el-checkbox>
            <el-checkbox v-model="filter.frequency5">{{ $t('Pricing.Fri') }}</el-checkbox>
            <el-checkbox v-model="filter.frequency6">{{ $t('Pricing.Sat') }}</el-checkbox>
            <el-checkbox v-model="filter.frequency7">{{ $t('Pricing.Sun') }}</el-checkbox>
          </el-form>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import CargoPopSelectInput from '@/components/Cargo/Common/CargoPopSelectInput/index'
import PriceDialog from '@/views/cargo/v0/Price/PriceReal/components/PriceReal/PriceDialog'
import SubscribeDialog from '@/views/cargo/v0/Price/PriceReal/components/PriceReal/SubscribeDialog'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import DateUtils from '@/utils/dateUtils'
import StrUtils from '@/utils/StrUtils'

export default {
  name: 'LclSearchBar',
  components: {
    CargoPopSelectInput,
    PriceDialog,
    SubscribeDialog,
    searchItem, cargoAdvanceSelect, cargoOfficeSelect
  },
  props: {
    showAdv: { type: Boolean, default: true }, // 显示高级查询
    expandAdv: { type: Boolean, default: false }, // 是否初始展开高级查询
    disabled: { type: Boolean, default: () => false }, // 禁用
    isShowCreatedBy: { type: Boolean, default: true }, // 是否显示录入人
    isManageModule: { type: Boolean, default: false },
    showSimple: { type: Boolean, default: true }, // 显示简单UI查询
    isShowContractNo: { type: Boolean, default: false },
    showPriceNo: { type: Boolean, default: false },
    filter: {
      type: Object, default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      showLevel: false, // 是否显示运价等级
      selectTypeNames: TYPE_NAMES,
      tiers: [],
      rdoGroupOrg: 'pol',
      rdoGroupDes: 'pod',
      simQueryPlaceholder: this.$t('Pricing.priceNoPrompt'), // 快捷检索 占位符
      isAdvancedQuery: false, // 是否为高级查询
      isShowingMoreSearchCondition: this.expandAdv,
      showDetail: false,
      keyWords: null,
      popSelectInputCols: [
        {
          colId: 'code',
          field: 'code',
          headerName: this.$t('Message.Code')
        }, {
          colId: 'chineseName',
          field: 'chineseName',
          headerName: this.$t('Message.ChineseName')
        }, {
          colId: 'englishName',
          field: 'englishName',
          headerName: this.$t('Message.EnglishName')
        }, {
          colId: 'countryCnName',
          field: 'countryCnName',
          headerName: this.$t('Message.Country')
        }, {
          colId: 'region',
          field: 'region',
          headerName: this.$t('Message.Region'),
          valueFormatter: (params) => {
            const { data } = params
            return this.$store.getters.language === 'zh' ? data.regionCnName : data.regionEnName
          }
        }
      ]
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    }
  },
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.init()
      this.toQuery()
    },
    isShowingMoreSearchCondition(newVal) {
      this.$emit('advToggle', newVal)
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.authedLevel = this.getAuthedLevel()
    },
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 查询
    toSimpleQuery() {
      this.proxy = {}
      this.proxy['isLimited'] = true
      this.proxy['level'] = 1
      this.proxy['isAdvanced'] = false
      this.proxy['tenantId'] = 0
      if (this.showPriceNo) {
        const keyWords = this.keyWords ? this.keyWords.trim() : ''
        if (!keyWords || keyWords.length === 0) {
          this.simQueryPlaceholder = ''
          this.$refs.keyword.focus()
          this.$message.warning(this.$t('Pricing.priceNoPrompt'))
          return
        }
        this.proxy['priceNo'] = keyWords
      } else {
        if (!this.filter.simPol) {
          this.$refs.simPol.$refs['advanceSelectRef'].$refs.reference.focus()
          return
        }
        if (!this.filter.simPod) {
          this.$refs.simPod.$refs['advanceSelectRef'].$refs.reference.focus()
          return
        }
        this.proxy['pol'] = this.filter.simPol
        this.proxy['pod'] = this.filter.simPod
        this.proxy['beginDate'] = DateUtils.formatStandardDate(new Date())
      }
      this.$emit('simSearchItemCallBack', this.proxy)
    },
    toAdvancedQuery() {
      this.proxy = {}
      this.proxy['priceNo'] = ''
      if (!this.proxy.hasOwnProperty('isLimited')) {
        this.proxy['isLimited'] = true
      }
      this.proxy['level'] = 1
      this.proxy['isAdvanced'] = true
      this.proxy['currency'] = this.filter.currency
      this.proxy['pol'] = this.filter.pol
      this.proxy['txtBookingAgent'] = this.filter.txtBookingAgent
      this.proxy['beginDate'] = this.filter.beginDate
      this.proxy['endDate'] = this.filter.endDate
      this.proxy[this.rdoGroupOrg] = this.filter[this.rdoGroupOrg]
      this.proxy[this.rdoGroupDes] = this.filter[this.rdoGroupDes]
      const FREQUENCYS = PriceUtils.FREQUENCYS
      const frequency = []
      for (const field of FREQUENCYS) {
        if (this.filter['frequency' + field]) {
          frequency.push('frequency' + field)
        }
      }
      frequency.join('/')
      this.proxy['frequencys'] = frequency
      if (this.isManageModule || this.isShowCreatedBy) {
        if (this.filter.cmbCreatedBy === 'createdBy') {
          this.proxy['createdBy'] = this.filter.createdBy
        }
        if (this.filter.cmbCreatedBy === 'branch') {
          this.proxy['branchId'] = this.filter.branch
        }
      }
      if (this.filter.carrier.length === 0) {
        this.proxy['carriers'] = this.filter.carrier
      } else {
        this.proxy['carrierScac'] = this.filter.carrier
      }
      this.setBooleanValue('direct')
      if (this.isShowContractNo && StrUtils.isEmpty(this.filter.contractNo)) {
        this.proxy['contractNo'] = this.filter.contractNo
      }
      this.$emit('advSearchItemResetCallBack', this.proxy)
    },
    setBooleanValue(field) {
      if (this.filter[field]) {
        this.proxy[field] = this.filter[field]
      }
    },
    getAuthedLevel() {
      if (this.$checkPermission(['PLDA_*_0'])) {
        return 0
      } else if (this.$checkPermission(['PLDA_*_1'])) {
        return 1
      } else if (this.$checkPermission(['PLDA_*_2'])) {
        return 2
      }
      return 99
    },
    upOrDownSearchCondition() {
      this.isShowingMoreSearchCondition = !this.isShowingMoreSearchCondition
      this.isAdvancedQuery = this.isShowingMoreSearchCondition
      this.$emit('click-more', this.isShowingMoreSearchCondition)
      this.$emit('update:isSimpleQuery', !this.isShowingMoreSearchCondition)
      // console.log('isShowingMoreSearchCondition', this.isShowingMoreSearchCondition)
    },
    keyWordBlur() {
      this.simQueryPlaceholder = this.$t('Pricing.priceNoPrompt')
    },
    resetSearch() {
      this.filter = PriceUtils.resetFilter(this.filter)
      this.filter.cmbCreatedBy = 'createdBy'
      this.filter.currency = 'USD'
      this.filter.level = '0'
      this.filter.saleState = -1
    },
    onLevelChanged() {
      this.$emit('onLevelChanged', { level: this.filter.level })
    }
  }
}
</script>
<style scoped>
</style>
